export default "<div class=\"center\">\r\n    <div class=\"box\">\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>\r\n";